// extracted by mini-css-extract-plugin
export default {"send":"studio-item_send__Q2vnN"};